import React, { useEffect, useState } from "react";
import { useApp } from "@/state/AppContext";
import { api, rows } from "@/lib/api";

/**
 * A member's own attendance record on their activity page — the recent days they were marked, at
 * whichever gym or class they attend. Self-hiding: a citizen with no marks renders nothing.
 */
export function MyAttendance() {
  const { t } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    api
      .get("/attendance/mine")
      .then((r) => {
        if (alive) setItems(rows(r.data));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!items.length) return null;

  return (
    <section className="mt-8 space-y-3" data-testid="my-attendance">
      <h2 className="font-heading text-xl font-bold">{t("attendance.title")}</h2>
      <ul className="space-y-2">
        {items.map((m, i) => (
          <li key={`${m.on_date}-${i}`} className="flex flex-wrap items-center justify-between gap-2 rounded-2xl border border-border p-4" data-testid={`my-attendance-${i}`}>
            <div>
              <p className="font-semibold">{m.business_name}</p>
              <p className="text-sm text-muted-foreground">{m.slot_name} · {m.on_date}</p>
            </div>
            <span
              className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${m.present ? "bg-emerald-100 text-emerald-700" : "bg-muted text-muted-foreground"}`}
              data-testid={`my-attendance-mark-${i}`}
            >
              {m.present ? t("attendance.present") : t("attendance.absent")}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
